import { useShopI18n } from '../../i18n'
import type { CheckoutStep } from '../types'

type ProgressStep = {
  step: CheckoutStep
  label: string
  order: number
  isCurrent: boolean
  isCompleted: boolean
}

type Props = {
  steps: ProgressStep[]
  currentOrder: number
}

export const CheckoutProgress = ({ steps, currentOrder }: Props) => {
  const { t } = useShopI18n()
  const current = steps.find((step) => step.isCurrent) ?? steps[0]

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" aria-label={t('checkout.progress.ariaLabel')}>
      <div className="flex items-center justify-between md:hidden">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{t('checkout.progress.mobileLabel')}</p>
        <p className="text-xs font-semibold text-slate-700">
          {t('checkout.progress.mobileCounter', { current: currentOrder, total: String(steps.length) })}
        </p>
      </div>
      <div className="mt-1 md:hidden">
        <p className="text-sm font-semibold text-slate-900">{current.label}</p>
      </div>

      <ol className="hidden items-center gap-2 md:flex" role="list">
        {steps.map((step, index) => (
          <li key={step.step} className="flex min-w-0 flex-1 items-center gap-2">
            <div className="flex min-w-0 items-center gap-2" aria-current={step.isCurrent ? 'step' : undefined}>
              <span
                className={`grid h-6 w-6 place-items-center rounded-full text-xs font-semibold ${
                  step.isCurrent
                    ? 'bg-slate-900 text-white'
                    : step.isCompleted
                    ? 'bg-emerald-600 text-white'
                    : 'bg-slate-200 text-slate-600'
                }`}
              >
                {step.order}
              </span>
              <span className={`truncate text-xs font-medium ${step.isCurrent ? 'text-slate-900' : 'text-slate-600'}`}>
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 ? <span className="h-px flex-1 bg-slate-200" aria-hidden /> : null}
          </li>
        ))}
      </ol>
    </section>
  )
}
